<template>
  <div style="height: 100%; pointer-events: all">
    <div
      v-if="mode === 'normal'"
      style="
        height: 940px;
        pointer-events: all;
        background-color: #070b20;
        color: #fff;
        padding-top: 160px;
      "
    >
      <!-- 导航 -->
      <el-row :gutter="40">
        <el-col :offset="3" :span="6">
          <div
            :style="{
              backgroundImage: `url(${require('./precise-fertility.jpg')})`,
            }"
            class="nav-item"
            @click="show('http://soil-gis.cn')"
          ></div>
        </el-col>
        <el-col :span="6">
          <div
            :style="{
              backgroundImage: `url(${require('./green-plant.jpg')})`,
            }"
            class="nav-item"
            @click="show('http://121.37.133.255/greenplantAdmin/Home.html')"
          ></div>
        </el-col>
        <el-col :span="6">
          <div
            :style="{
              backgroundImage: `url(${require('./soil-fertility.jpg')})`,
            }"
            class="nav-item"
            @click="show('http://60.166.14.188:1680/cfeng/')"
          ></div>
        </el-col>
      </el-row>

      <!-- 内容 -->
      <el-dialog
        :visible.sync="dialogShow"
        append-to-body
        width="1440px"
        top="2%"
      >
        <iframe
          :src="url"
          frameborder="0"
          style="width: 100%; min-height: 740px"
        ></iframe>
      </el-dialog>
    </div>
    <div
      v-else
      style="position: absolute; width: 100%; height: 100%; top: 0; left: 0"
    >
      <iframe
        style="position: absolute; width: 100%; height: 100%; top: 0; left: 0"
        src="http://60.166.14.188:1680/cfeng/"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFertility',
  data() {
    return {
      dialogShow: false,
      url: undefined,
      mode: 'normal',
    }
  },
  methods: {
    show(x) {
      if (x === 'http://60.166.14.188:1680/cfeng/') {
        this.mode = ''
      } else {
        this.mode = 'normal'
        this.url = x
        this.$nextTick(() => {
          this.dialogShow = !!x
        })
      }
    },
  },
}
</script>
<style scoped>
.nav-item {
  height: 280px;
  cursor: pointer;
  border: solid 1px #070b20;
  border-radius: 30px;
}
.nav-item:hover {
  border: solid 2px #9cd9fc;
}
</style>


// WEBPACK FOOTER //
// src/components/product/Fertility.vue